var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxesPacking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9C15 8.17157 14.3284 7.5 13.5 7.5H1.5C0.671573 7.5 0 8.17157 0 9V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V9ZM13.5 9H1.5V10.5H13.5V9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C9 2.17157 9.67157 1.5 10.5 1.5H22.5C23.3284 1.5 24 2.17157 24 3V19.5C24 20.3284 23.3284 21 22.5 21H15.75C15.3358 21 15 20.6642 15 20.25C15 19.8358 15.3358 19.5 15.75 19.5H22.5V3H10.5V5.25C10.5 5.66421 10.1642 6 9.75 6C9.33579 6 9 5.66421 9 5.25V3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H1.5V19.5C1.5 20.3284 2.17157 21 3 21H12C12.8284 21 13.5 20.3284 13.5 19.5V12H12V19.5H3V12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.25C4.5 13.8358 4.83579 13.5 5.25 13.5H9.75C10.1642 13.5 10.5 13.8358 10.5 14.25C10.5 14.6642 10.1642 15 9.75 15H5.25C4.83579 15 4.5 14.6642 4.5 14.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5303 13.773C21.2374 14.0659 20.7626 14.0659 20.4697 13.773L19.0606 12.2659V17.9826C19.0606 18.3968 18.7249 18.7326 18.3106 18.7326C17.8964 18.7326 17.5606 18.3968 17.5606 17.9826V12.2659L16.045 13.773C15.7522 14.0659 15.2773 14.0659 14.9844 13.773C14.6915 13.4801 14.6915 13.0052 14.9844 12.7123L17.727 9.96967C18.0199 9.67678 18.4948 9.67678 18.7877 9.96967L21.5303 12.7123C21.8232 13.0052 21.8232 13.4801 21.5303 13.773Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxesPacking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boxes-packing.4ce65bfcc5735353ff492c81e95ea5ee.svg";